"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallApiExecutor = void 0;
exports.isPromise = isPromise;
class AsyncQueue {
    constructor() {
        this.queue = Promise.resolve();
    }
    enqueue(operation) {
        return new Promise((resolve, reject) => {
            this.queue = this.queue.then(operation).then(resolve).catch(reject);
        });
    }
    cancel() { }
}
class CallApiExecutor {
    constructor(isAsyncCall) {
        this.isAsyncCall = isAsyncCall;
        this.queue = new AsyncQueue();
    }
    execute(task) {
        if (!this.isAsyncCall) {
            this.queue.enqueue(task);
            return 0;
        }
        let tmp = task();
        return tmp;
    }
}
exports.CallApiExecutor = CallApiExecutor;
function isPromise(value) {
    return value != null && typeof value.then === 'function';
}
